var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 511.801,
    height: 511.898,
    viewBox: "0 0 511.801 511.898",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(-0.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52844",
    "data-name": "Path 52844",
    d: "M510.949,150.5c-1.2-27.2-5.6-45.9-11.9-62.1a131.13,131.13,0,0,0-74.9-74.9c-16.3-6.3-34.9-10.7-62.1-11.9-27.4-1.3-36.1-1.6-105.6-1.6s-78.2.3-105.5,1.5c-27.2,1.2-45.9,5.6-62.1,11.9A124.9,124.9,0,0,0,43.449,43a126.033,126.033,0,0,0-29.5,45.3c-6.3,16.3-10.7,34.9-11.9,62.1C.75,177.8.449,186.5.449,256s.3,78.2,1.5,105.5c1.2,27.2,5.6,45.9,11.9,62.1a131.109,131.109,0,0,0,74.9,74.9c16.3,6.3,34.9,10.7,62.1,11.9,27.3,1.2,36,1.5,105.5,1.5s78.2-.3,105.5-1.5c27.2-1.2,45.9-5.6,62.1-11.9a130.934,130.934,0,0,0,74.9-74.9c6.3-16.3,10.7-34.9,11.9-62.1,1.2-27.3,1.5-36,1.5-105.5S512.148,177.8,510.949,150.5Zm-46.1,209c-1.1,25-5.3,38.5-8.8,47.5a84.915,84.915,0,0,1-48.6,48.6c-9,3.5-22.6,7.7-47.5,8.8-27,1.2-35.1,1.5-103.4,1.5s-76.5-.3-103.4-1.5c-25-1.1-38.5-5.3-47.5-8.8a78.77,78.77,0,0,1-29.4-19.1,79.585,79.585,0,0,1-19.1-29.4c-3.5-9-7.7-22.6-8.8-47.5-1.2-27-1.5-35.1-1.5-103.4s.3-76.5,1.5-103.4c1.1-25,5.3-38.5,8.8-47.5a77.805,77.805,0,0,1,19.2-29.4,79.463,79.463,0,0,1,29.4-19.1c9-3.5,22.6-7.7,47.5-8.8,27-1.2,35.1-1.5,103.4-1.5,68.4,0,76.5.3,103.4,1.5,25,1.1,38.5,5.3,47.5,8.8a78.712,78.712,0,0,1,29.4,19.1,79.568,79.568,0,0,1,19.1,29.4c3.5,9,7.7,22.6,8.8,47.5,1.2,27,1.5,35.1,1.5,103.4S466.051,332.5,464.852,359.5Zm0,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52845",
    "data-name": "Path 52845",
    d: "M256.449,124.5A131.5,131.5,0,1,0,387.949,256,131.533,131.533,0,0,0,256.449,124.5Zm0,216.8a85.3,85.3,0,1,1,85.3-85.3A85.314,85.314,0,0,1,256.449,341.3Zm0,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52846",
    "data-name": "Path 52846",
    d: "M423.852,119.3a30.7,30.7,0,1,1-30.7-30.7A30.7,30.7,0,0,1,423.852,119.3Zm0,0",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.2b154f35c4838ac6b76f9d9285514427.svg";
export { ForwardRef as ReactComponent };